/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoChangeContainerStageInput = {
    clientMutationId?: string | null;
    slug: string;
    stage: string;
};
export type ContainerReleaseRequestStageChangeMutationVariables = {
    input: infoChangeContainerStageInput;
};
export type ContainerReleaseRequestStageChangeMutationResponse = {
    readonly infoChangeContainerStage: {
        readonly clientMutationId: string | null;
    } | null;
};
export type ContainerReleaseRequestStageChangeMutation = {
    readonly response: ContainerReleaseRequestStageChangeMutationResponse;
    readonly variables: ContainerReleaseRequestStageChangeMutationVariables;
};



/*
mutation ContainerReleaseRequestStageChangeMutation(
  $input: infoChangeContainerStageInput!
) {
  infoChangeContainerStage(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoChangeContainerStagePayload",
    "kind": "LinkedField",
    "name": "infoChangeContainerStage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContainerReleaseRequestStageChangeMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContainerReleaseRequestStageChangeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cd7b24879b899092e73651a836f5cfc2",
    "id": null,
    "metadata": {},
    "name": "ContainerReleaseRequestStageChangeMutation",
    "operationKind": "mutation",
    "text": "mutation ContainerReleaseRequestStageChangeMutation(\n  $input: infoChangeContainerStageInput!\n) {\n  infoChangeContainerStage(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'a81bb5e1784dbf9356eb062781e5f511';
export default node;
